import React from 'react'
import { Chip, Avatar } from '@mui/material'
import { ErrorOutline } from '@mui/icons-material'
import useStyles from './styles'

export interface IErrorBadgeProps {
  count: number
}

function ErrorBadge(props: IErrorBadgeProps) {
  const { classes } = useStyles()
  const { count = 0 } = props

  if (!count) {
    return null
  }

  return (
    <Chip
      title={(count === 1) ? '1 error' : `${count} errors`}
      color="primary"
      avatar={(
        <Avatar className={classes.avatar}>
          <ErrorOutline />
        </Avatar>
      )}
      className={classes.chip}
      label={count}
    />
  )
}

export default React.memo(ErrorBadge)
